@if (bridgeComponent.isLoading) {
  <div>
    <my-spinner></my-spinner>
  </div>
}
@if (!bridgeComponent.isLoading) {
  <div>
    <ng-container *ngTemplateOutlet="bridgeParamsTemplate"></ng-container>
  </div>
}
